<div class="gup-C-loginBox">

    <figure class="gup-C-loginBox__head">
        <img src="../../../../assets/210329_L_Up_gestion_exp_W1_RVB.svg" class="gup-O-logo"/>
    </figure>

    <form *ngIf="!(needChoice$ | async) && !(isFirstTimeLogin$ | async); else delegationPickerOrEditPasswordTemplate"
          [formGroup]="form"
          [kalLoading]="loading"
          (ngSubmit)="login()"
          kalLoadingMessage="Connexion en cours"
          kalTheme="reverse"
          novalidate
          class="gup-C-loginBox__form">

        <kal-form-field kalTheme="reverse">
            <kal-input formControlName="login"
                       id="user_login_email"
                       label="Identifiant"
                       placeholder="Identifiant"
                       kalTheme="reverse"
                       required>
            </kal-input>
        </kal-form-field>
        <p class="gup-O-msg -error" *ngIf="error?.login as errorMessage">
            {{ errorMessage }}
        </p>

        <kal-form-field kalTheme="reverse">
            <kal-input formControlName="password"
                       [autocomplete]="false"
                       id="user_login_password"
                       label="Mot de passe"
                       placeholder="Mot de passe"
                       kalTheme="reverse"
                       required
                       type="password">
            </kal-input>
        </kal-form-field>
        <p class="gup-O-msg -error" *ngIf="error?.password as errorMessage">
            {{ errorMessage }}
        </p>


        <kal-form-field kalTheme="reverse">
            <kal-input formControlName="ceName"
                       id="user_login_ce_name"
                       label="Organisation"
                       placeholder="Organisation"
                       kalTheme="reverse"
                       required>
            </kal-input>
        </kal-form-field>

        <p class="gup-O-msg -error" *ngIf="error?.ceName as errorMessage">
            {{ errorMessage }}
        </p>

        <kal-form-field kalTheme="reverse"
                        class="without-label">
            <kal-checkbox formControlName="storeCredentials"
                          id="user_login_store_credentials"
                          kalTheme="reverse switch"
                          label="Enregistrer mes informations de connexion">
            </kal-checkbox>
        </kal-form-field>

        <p *ngIf="error?.other as errorMessage" class="gup-O-msg  -error small">{{ errorMessage }}</p>

        <div class="gup-O-list gup-C-validationArea">
            <div class="gup-O-list__item">
                <kal-button id="user_login_submit"
                            kalTheme="primary large"
                            [disabled]="form.invalid"
                            type="submit">
                    Se connecter
                </kal-button>
            </div>
        </div>

    </form>

    <ng-template #delegationPickerOrEditPasswordTemplate>
        <app-multi-delegations *ngIf="needChoice$ | async"/>

        <ng-container *ngIf="isFirstTimeLogin$ | async">
            <p class="gup-U-color--orange gup-U-margin-bottom--small">
                Pour des raisons de sécurité, veuillez modifier votre mot de passe en respectant les critères de saisie.
            </p>

            <app-shared-edit-password isThemeReverse [formControl]="passwordEditControl"/>

            <div class="gup-O-list gup-C-validationArea -right editPassword">
                <div class="gup-O-list__item">
                    <kal-button kalTheme="primary"
                                (click)="editFirstTimeConnectionPassword()"
                                [disabled]="passwordEditControl.invalid">
                        Modifier le mot de passe
                    </kal-button>
                </div>
                <div class="gup-O-list__item">
                    <kal-button kalTheme="reverse secondary"
                                (click)="logout()">
                        Annuler
                    </kal-button>
                </div>
            </div>
        </ng-container>
    </ng-template>

  <div class="gup-C-loginBox__mention">UpExpert V25.11.2</div>


</div>
